import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { unwrapResponse } from '../http/unwrap-response';
import { ResponseObj } from '../models/response.model';
import { CreateStaffRequest, StaffMember } from '../models/staff.model';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class StaffService {
  private readonly baseUrl = `${environment.apiBaseUrl}/outward-approval/staff`;

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService,
  ) {}

  getStaff(): Observable<StaffMember[]> {
    return this.http
      .get<ResponseObj<StaffMember[]>>(this.baseUrl)
      .pipe(unwrapResponse());
  }

  createStaff(
    request: Omit<CreateStaffRequest, 'sessionToken'>,
  ): Observable<void> {
    const sessionToken = this.authService.currentSession()?.sessionToken ?? '';
    const body: CreateStaffRequest = { ...request, sessionToken };
    return this.http
      .post<ResponseObj<unknown>>(this.baseUrl, body)
      .pipe(unwrapResponse(), map(() => undefined));
  }
}
